"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { STATS } from "@/constants/home.constants";
export function useCounterAnimation() {
  const $ = _c(4);
  const [counterValues, setCounterValues] = useState(_temp2);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const statsEl = document.getElementById("stats-section");
      if (!statsEl) {
        return;
      }
      const observer = new IntersectionObserver(t2 => {
        const [entry] = t2;
        if (!entry.isIntersecting) {
          return;
        }
        const start = performance.now();
        const animate = now => {
          const progress = Math.min((now - start) / 1200, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          setCounterValues(STATS.map(item => Math.floor(item.value * eased)));
          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };
        requestAnimationFrame(animate);
        observer.disconnect();
      }, {
        threshold: 0.3
      });
      observer.observe(statsEl);
      return () => observer.disconnect();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== counterValues) {
    t2 = {
      counterValues
    };
    $[2] = counterValues;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp2() {
  return STATS.map(_temp);
}
function _temp() {
  return 0;
}